import script from "./Zujuan.vue?vue&type=script&setup=true&lang=js"
export * from "./Zujuan.vue?vue&type=script&setup=true&lang=js"

import "./Zujuan.vue?vue&type=style&index=0&id=4184e496&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4184e496"]])

export default __exports__